<div class="client-review">
  <div class="client-review-header">
    <div class="client-review-header-stars">
      @for (star of [].constructor(5); let index = $index; track index) {
        <img height="20px" width="20px" src="/assets/icons/star-green.svg" alt="star" />
      }
    </div>

    @if (data.date) {
      <p class="text-green-800">{{ data.date }}</p>
    }
  </div>

  <div class="client-review-body">
    @if (data.summary) {
      <h3 class="semi-bold text-green-800">{{ data.summary }}</h3>
    }
    <p class="text-green-800">{{ data.review }}</p>
  </div>

  <div class="client-review-footer">
    <img [src]="data.img" alt="client" height="44" width="44" />

    <div>
      <h3 class="semi-bold text-green-800">{{ data.from }}</h3>
      <p class="text-green-800">{{ data.details }}</p>
    </div>
  </div>
</div>
